<template>
	<el-upload ref="upload" :action="action" :auto-upload="true" :headers="headers" :show-file-list="false"
		:on-success="handleSuccess">
		<slot></slot>
	</el-upload>
</template>

<script>
import apis from '@/http/api'
import store from '@/store'
import { baseURL } from '@/config.js'

const uploadUrl = baseURL + apis.upload

export default {
	name: "UploadPictureCard",
	props: {
		action: { type: String, default: uploadUrl },
		headers: {
			type: Object, default: () => ({
				token: store.state.token
			})
		},
	},
	data() {
		return {
		};
	},
	watch: {
	},
	methods: {
		handleSuccess(response, file, fileList) {
			console.log(response, file, fileList)
			if (response.code == 1) {
				this.$emit('success', response.data)
			}
		},
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload {
	width: 100%;
}
</style>
